export class DsrConstants {
  static navigationWidth = 300;
  static rightSideWidth = 300;
  static sideMargin = 16;
  static contentPadding = 16;
}
